import { Navigate, useParams } from "react-router-dom";
import BeachDestinationDetailView from "@/components/site-officiel/ivoirexperience/beach-destination-detail";
import { getBeachDestinationDetail } from "@/lib/data/beach-destination-details";

export default function BeachDestinationPage() {
    const { slug } = useParams<{ slug: string }>();
    const destination = slug ? getBeachDestinationDetail(slug) : undefined;

    if (!destination) {
        return <Navigate to="/ivoirexperience/the-place-to-be" replace />;
    }

    return <BeachDestinationDetailView destination={destination} />;
}
